import React, { useState, useEffect } from 'react';
import QuestionWrapper from '../../../wrappers/question_wrapper/index';

import styles from '../questionnaire.module.css';

export default function OptionsAndOther({
  onBack,
  onSubmit,
  title,
  para = '',
  keyForAnswer,
  yesState,
  answers,
  choices = ['foo', 'bar', 'baz'],
  showOther = true,
  selectOne = false,
  otherTxt = 'Type other...',
  required = true,
}) {
  let defaultOther = '';
  let defaultSelected = answers[keyForAnswer] || [];
  if (selectOne && answers[keyForAnswer] && !choices.includes(answers[keyForAnswer])) {
    defaultOther = answers[keyForAnswer];
    defaultSelected = [];
  }

  if (
    !selectOne &&
    Array.isArray(answers[keyForAnswer]) &&
    answers[keyForAnswer].filter((a) => !choices.includes(a)).length !== 0
  ) {
    defaultOther = answers[keyForAnswer].filter((a) => !choices.includes(a))[0];
  }
  const [selected, setSelected] = useState(defaultSelected);
  const [other, setOther] = useState(defaultOther);

  useEffect(() => {
    setSelected(answers[keyForAnswer] || []);
  }, [answers, keyForAnswer]);

  const handleSubmit = (e) => {
    e.preventDefault();
    let newSelected = { [keyForAnswer]: selected };
    if (selectOne && Array.isArray(selected)) {
      newSelected = { [keyForAnswer]: '' };
    }
    if (other !== '') {
      newSelected.other = other;
    }
    onSubmit(newSelected, yesState);
  };

  const onClick = (choice) => () => {
    if (selectOne) {
      if (!Array.isArray(selected) && selected === choice) {
        setSelected([]);
      } else {
        setSelected(choice);
        setOther('');
      }
      return;
    }
    if (selected.includes(choice)) {
      setSelected(selected.filter((c) => c !== choice));
    } else {
      setSelected(selected.concat([choice]));
    }
  };

  const onOtherChange = (event) => {
    setOther(event.target.value);
    if (selectOne) {
      setSelected([]);
    }
  };

  return (
    <QuestionWrapper onSubmit={handleSubmit} onBack={onBack} isDisabled={required && !selected.length && !other.trim()}>
      <div className={styles.question}>{title}</div>
      <p className={styles.question_para}>{para}</p>
      {choices.map((choice) => {
        const isSelected = selectOne ? selected == choice : selected.includes(choice);
        return (
          <div key={choice} className={`${styles.tile} ${styles.two_column}`}>
            <label key={choice} className={`${styles.preexisting} ${isSelected ? styles.active_checkbox : ''}`}>
              <input onClick={onClick(choice)} type='checkbox' name={choice} value='value' />
              {choice}
            </label>
          </div>
        );
      })}
      {showOther && (
        <div className={`${styles.tile} material-input light ${styles.marg_center}`}>
          <input placeholder={otherTxt} type='text' name='other' value={other} onChange={onOtherChange} />
          <span className='bar'></span>
        </div>
      )}
    </QuestionWrapper>
  );
}
